import React from "react";

const Tooltip = ({ text, children, showDescription = true }) => {
  return (
    <div className="relative flex items-center group z-40">
      {/* Tooltip text */}
      {text && (
        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 hidden group-hover:flex items-center justify-center w-max px-3 py-2 bg-customGrey-border  text-sm rounded shadow-lg transition-opacity duration-200">
          <div className="max-w-sm">
            {showDescription && (
              <p className="text-xs font-semibold text-black-secondary py-2">
                Description
              </p>
            )}
            <p className="break-words">{text}</p>
          </div>
        </div>
      )}

      {/* Tooltip trigger element */}
      <div className="cursor-pointer">{children}</div>
    </div>
  );
};

export default Tooltip;
